var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/three_columns.d29fdfb5.png","uri@2x": __webpack_public_path__ + "static/media/three_columns.cce06b02.png","uri@3x": __webpack_public_path__ + "static/media/three_columns.2c644fac.png",
    width: 32,
    height: 32
});